import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-almond" }
const _hoisted_2 = { class: "absolute top-0 right-0 flex items-center gap-2 m-2 sm:gap-4 sm:m-4" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "container mx-auto p-2 sm:p-4 h-screen flex flex-col" }
const _hoisted_6 = { class: "flex-grow" }
const _hoisted_7 = {
  key: 1,
  class: "mb-4 space-y-4"
}
const _hoisted_8 = { class: "relative" }
const _hoisted_9 = { class: "flex flex-col sm:flex-row sm:items-center gap-4" }
const _hoisted_10 = { class: "flex justify-between sm:justify-start items-center flex-grow gap-4" }
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = {
  for: "voice-mode-toggle",
  class: "inline-flex items-center cursor-pointer"
}
const _hoisted_13 = { class: "flex items-center gap-2" }
const _hoisted_14 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ApiKeyModal = _resolveComponent("ApiKeyModal")!
  const _component_ConversationHistory = _resolveComponent("ConversationHistory")!
  const _component_ArticleDisplay = _resolveComponent("ArticleDisplay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.started)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearApiKey && _ctx.clearApiKey(...args)), ["prevent"])),
              href: "#",
              class: "flex items-center text-sm sm:text-base text-yellow-600 hover:text-yellow-700"
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['far', 'trash-alt'],
                class: "mr-1 sm:mr-2"
              }),
              _cache[10] || (_cache[10] = _createTextVNode(" API Key "))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.started)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.startOver && _ctx.startOver(...args)), ["prevent"])),
              href: "#",
              class: "flex items-center text-sm sm:text-base text-yellow-600 hover:text-yellow-700"
            }, " Start Over ")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[14] || (_cache[14] = _createElementVNode("h1", { class: "text-2xl sm:text-3xl font-bold mb-2 sm:mb-4 text-center text-gunmetal" }, " The Socratic LLM ", -1)),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.showApiKeyModal)
          ? (_openBlock(), _createBlock(_component_ApiKeyModal, {
              key: 0,
              onSave: _ctx.saveApiKey
            }, null, 8, ["onSave"]))
          : _createCommentVNode("", true),
        (!_ctx.started)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.topic) = $event)),
                  onKeydown: [
                    _cache[3] || (_cache[3] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.startInterview && _ctx.startInterview(...args)), ["exact"]), ["enter"])),
                    _cache[4] || (_cache[4] = _withKeys(_withModifiers(() => {}, ["shift","stop"]), ["enter"]))
                  ],
                  placeholder: "Topic you'd like to discuss...",
                  class: "w-full p-3 sm:p-4 border rounded-lg focus:outline-none focus:ring bg-white text-black text-sm",
                  rows: "4"
                }, null, 544), [
                  [_vModelText, _ctx.topic]
                ]),
                (_ctx.voiceMode)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleTopicVoiceInput && _ctx.toggleTopicVoiceInput(...args))),
                      class: _normalizeClass(["absolute bottom-2 right-2 p-2 rounded-full hover:bg-gray-100", { 'text-red-500': _ctx.isRecordingTopic }])
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: ['fas', 'microphone'] })
                    ], 2))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("label", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        id: "voice-mode-toggle",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.voiceMode) = $event)),
                        class: "sr-only peer",
                        onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleVoiceModeToggle && _ctx.handleVoiceModeToggle(...args)))
                      }, null, 544), [
                        [_vModelCheckbox, _ctx.voiceMode]
                      ]),
                      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600" }, null, -1)),
                      _cache[12] || (_cache[12] = _createElementVNode("span", { class: "ml-3 text-sm font-medium text-gunmetal" }, "Voice Mode", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _cache[13] || (_cache[13] = _createElementVNode("label", {
                      for: "articleType",
                      class: "text-sm font-medium text-gunmetal"
                    }, " What are you writing? ", -1)),
                    _withDirectives(_createElementVNode("select", {
                      id: "article-type",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.articleType) = $event)),
                      class: "h-9 border rounded text-sm px-2 py-1"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articleTypes, (type) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: type.id,
                          value: type.id
                        }, _toDisplayString(type.label), 9, _hoisted_14))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.articleType]
                    ])
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.startInterview && _ctx.startInterview(...args))),
                  class: "w-full sm:w-auto h-14 px-8 bg-khaki text-black rounded hover:bg-walnutBrown hover:text-white text-sm font-medium transition-colors duration-200 whitespace-nowrap"
                }, " Start Interview ")
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.started && !_ctx.finished)
          ? (_openBlock(), _createBlock(_component_ConversationHistory, {
              key: 2,
              ref: "conversationHistory",
              conversation: _ctx.conversation,
              currentQuestion: _ctx.currentQuestion,
              isLoading: _ctx.isLoading,
              voiceMode: _ctx.voiceMode,
              onSubmitAnswer: _ctx.submitAnswer,
              onGetAlternativeQuestion: _ctx.getAlternativeQuestion,
              onFinishInterview: _ctx.finishInterview
            }, null, 8, ["conversation", "currentQuestion", "isLoading", "voiceMode", "onSubmitAnswer", "onGetAlternativeQuestion", "onFinishInterview"]))
          : _createCommentVNode("", true),
        (_ctx.finished)
          ? (_openBlock(), _createBlock(_component_ArticleDisplay, {
              key: 3,
              articleMarkdown: _ctx.articleMarkdown,
              onStartOver: _ctx.startOver,
              onReturnToConversation: _ctx.returnToConversation
            }, null, 8, ["articleMarkdown", "onStartOver", "onReturnToConversation"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}